import { SVGProps } from 'react';

export const Revenue = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.14392 6.65015H6.23447C6.00503 6.65015 5.81883 6.83636 5.81883 7.0658C5.81883 7.29523 6.00503 7.48144 6.23447 7.48144H7.06574C8.21123 7.48144 9.14392 8.41415 9.14392 9.55967C9.14392 10.5639 8.42903 11.4026 7.48138 11.5963V12.4692H5.81883V11.6379H4.15628V9.97531H7.06574C7.29517 9.97531 7.48138 9.7891 7.48138 9.55967C7.48138 9.33023 7.29517 9.14402 7.06574 9.14402H6.23447C5.08897 9.14402 4.15628 8.21131 4.15628 7.0658C4.15628 6.0616 4.87118 5.22283 5.81883 5.02914V4.15628H7.48138V4.98757H9.14392V6.65015ZM13.3004 0.83129C13.3004 0.543663 13.1507 0.275988 12.9063 0.124693C12.6611 -0.0274325 12.3544 -0.0407332 12.0975 0.0872854L9.20386 1.53456L7.11154 0.139657C6.83223 -0.0465522 6.46814 -0.0465522 6.18883 0.139657L4.09651 1.53456L1.20285 0.0872854C0.945989 -0.0407332 0.639249 -0.0274325 0.394024 0.124693C0.149629 0.275988 0 0.543663 0 0.83129V15.7945C0 16.083 0.149629 16.3498 0.394024 16.5019C0.527858 16.5842 0.67915 16.6258 0.831273 16.6258C0.958458 16.6258 1.08564 16.5967 1.20285 16.5377L4.09651 15.0912L6.18883 16.4861C6.46814 16.6723 6.83223 16.6723 7.11154 16.4861L9.20303 15.0912L10.1864 15.5834L13.3004 12.4693V0.83129Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5315 13.5439L14.9629 17.1118L13.0568 15.2065L11.8813 16.3811L14.9629 19.4636L19.707 14.7186L18.5315 13.5439Z"
      fill="currentColor"
    />
  </svg>
);
